import Package from '../../package.json'

export default {
  install: function (Vue, options) {
    Vue.prototype.$package = Package
  }
}



// WEBPACK FOOTER //
// ./src/plugins/package.js